import React, { useState } from "react";
import CheckBox from "../../../../Components/CheckBox/CheckBox";
import DropDown1 from "../../../../Components/DropDown1/DropDown1";
import "./ChiefDashbord_filters.css";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/colors/purple.css";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import transition from "react-element-popper/animations/transition";
import opacity from "react-element-popper/animations/opacity";

function ChiefDashbord_filters() {
    const optionsList1 = [
        { label: "سازنده", value: "سازنده" },
        { label: "غیر سازنده", value: "غیر سازنده" },
    ];
    const optionsList2 = [
        { label: "جدید", value: "جدید" },
        { label: "ارجاع شده", value: "ارجاع شده" },
        { label: "درحال ارزیابی", value: "درحال ارزیابی" },
        { label: "تکمیل شده", value: "تکمیل شده" },
    ];
    const optionsList3 = [
        { label: "پرداخت شده ( آنلاین )", value: "پرداخت شده ( آنلاین )" },
        { label: "پرداخت شده ( نقدی )", value: "پرداخت شده ( نقدی )" },
        { label: "پرداخت شده ( واریزی )", value: "پرداخت شده ( واریزی )" },
        { label: "پرداخت نشده", value: "پرداخت نشده" },
    ];
    const [Datevalue, setDateValue] = useState(null);
    const handleDateChange = (value) => {
        setDateValue(Datevalue);
    };
    return (
        <div className="ChiefDashbord_filters">
            <span className="ChiefDashbord_filtersTitle">فیلتر بر اساس :</span>
            <div className="ChiefDashbord_filtersContainer">
                <DropDown1 title="سازندگان" optionsList={optionsList1} />
                <DropDown1 title="وضعیت" optionsList={optionsList2} />
                <DropDown1 title="نوع پرداخت" optionsList={optionsList3} />
            </div>
            <div style={{ backgroundColor: "#ff6348", color: "snow", padding: "6px 32px", borderRadius: "12px", fontSize: "12px" }}>جستجو</div>
        </div>
    );
}

function CustomInput1({ openCalendar, value, handleValueChange }) {
    return <input className="DP_DateInput" onFocus={openCalendar} value={value} onChange={handleValueChange} placeholder="  /     /  " />;
}

export default ChiefDashbord_filters;
